"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectChevronIconStyles = exports.disabledIconStyles = exports.combineBackgroundIconStyles = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _constants = require("../form/constants");

var _icons = require("../icons");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var sharedIconStyles = {
  backgroundRepeat: 'no-repeat'
};

var combineBackgroundIconStyles = function combineBackgroundIconStyles() {
  var result = {};

  for (var _len = arguments.length, iconStyles = new Array(_len), _key = 0; _key < _len; _key++) {
    iconStyles[_key] = arguments[_key];
  }

  iconStyles.forEach(function (style) {
    Object.keys(style).forEach(function (property) {
      if (!result[property]) {
        result[property] = style[property];
      } else {
        result[property] = "".concat(result[property], ", ").concat(style[property]);
      }
    });
  });
  return result;
};

exports.combineBackgroundIconStyles = combineBackgroundIconStyles;

var getBackgroundPositionStyle = function getBackgroundPositionStyle(position, isRTL) {
  var leading = "".concat(_constants.INPUT_PADDING_DEFAULT, "px ").concat(_constants.INPUT_PADDING_DEFAULT + 2, "px");
  var trailing = "calc(100% - ".concat(_constants.INPUT_PADDING_DEFAULT, "px) center");

  if (!isRTL) {
    return position === 'leading' ? leading : trailing;
  }

  return position === 'leading' ? trailing : leading;
};

var disabledIconStyles = function disabledIconStyles(_ref) {
  var theme = _ref.theme,
      disabled = _ref.disabled;
  if (!disabled) return {};
  return _objectSpread(_objectSpread({}, sharedIconStyles), {}, {
    backgroundPosition: getBackgroundPositionStyle('leading', theme.isRTL),
    paddingLeft: "".concat(_constants.INPUT_PADDING_WITH_ICON, "px"),
    backgroundImage: _icons.IconDisabled.getBackgroundImage({
      theme: theme,
      color: 'neutral50'
    })
  });
};

exports.disabledIconStyles = disabledIconStyles;

var selectChevronIconStyles = function selectChevronIconStyles(_ref2) {
  var theme = _ref2.theme,
      disabled = _ref2.disabled,
      warning = _ref2.warning,
      error = _ref2.error;
  var color = 'primary70';
  if (disabled) color = 'neutral50';else if (error) color = 'red70';else if (warning) color = 'yellow70';
  return _objectSpread(_objectSpread({}, sharedIconStyles), {}, {
    paddingRight: "".concat(_constants.INPUT_PADDING_WITH_ICON, "px"),
    backgroundPosition: getBackgroundPositionStyle('trailing', theme.isRTL),
    backgroundImage: _icons.IconChevronDown.getBackgroundImage({
      theme: theme,
      color: color
    })
  });
};

exports.selectChevronIconStyles = selectChevronIconStyles;